<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-tabs v-model="tab" background-color="black" dark onchange="clearOrder()">
        <v-tab v-for="item in items" :key="item.id">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.id" :transition="false">
          <div v-if="item.id === 1">
            <OrderElectricityForm
              v-model="order"
              :title="title('elektřina')"
              :saving="saving"
              :edit="false"
              :customer="customer"
              @save="saveElectricityOrder"
            />
          </div>
          <div v-if="item.id === 2">
            <OrderGasForm
              v-model="order"
              :title="title('plyn')"
              :saving="saving"
              :edit="false"
              :customer="customer"
              @save="saveGasOrder"
            />
          </div>
          <div v-if="item.id === 3">
            <OrderElectricityWorkForm
              v-model="order"
              :title="title('elektrikář')"
              :saving="saving"
              :edit="false"
              :customer="customer"
              @save="saveElectricityWorkOrder()"
            />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import OrderElectricityForm from '@/components/forms/OrderElectricityForm'
import OrderGasForm from '@/components/forms/OrderGasForm'
import OrderElectricityWorkForm from '../../../components/forms/OrderElectricityWorkForm'

export default {
  name: 'OrderAdd',
  components: { OrderElectricityWorkForm, OrderGasForm, OrderElectricityForm },
  data() {
    return {
      assign: false,
      customer: false,
      order: {
        assignId: null,
        customerId: null,
        electricityOrder: {},
        electricityWorkOrder: {},
        gasOrder: {},
        moveOrder: {},
        questionOrder: {},
      },
      tab: null,
      items: [
        { id: 1, name: 'Elektřina' },
        { id: 2, name: 'Plyn' },
        { id: 3, name: 'Elektrikář' },
      ],
      loading: false,
      saving: false,
    }
  },
  created() {
    if (this.$route.params.customerId) {
      this.customer = true
      this.order.customerId = this.$route.params.customerId
    }
    if (this.$route.params.assignId) {
      this.assign = true
      this.customer = true
      this.order.assignId = this.$route.params.assignId
      this.order.customerId = this.$route.params.customerId
    }
  },
  methods: {
    ...mapActions({
      createElectricityOrder: 'electricity/createOrder',
      createElectricityWorkOrder: 'electricity/createWorkOrder',
      createGasOrder: 'gas/createOrder',
    }),
    title(type) {
      if (this.assign) {
        return `Převod na objednávku | ${type}`
      } else {
        return `Nová objednávka | ${type}`
      }
    },
    clearOrder() {
      this.order = {
        assignId: null,
        giftID: null,
      }
      if (this.$route.params.customerId) {
        this.order.customerId = this.$route.params.customerId
      }
      if (this.$route.params.assignId) {
        this.order.assignId = this.$route.params.assignId
        this.order.customerId = this.$route.params.customerId
      }
    },
    saveElectricityOrder() {
      this.saving = true
      this.createElectricityOrder(this.order)
        .then(() => {
          this.$router.back()
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveElectricityWorkOrder() {
      this.saving = true
      this.createElectricityWorkOrder(this.order)
        .then(() => {
          this.$router.back()
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveGasOrder() {
      this.saving = true
      this.createGasOrder(this.order)
        .then(() => {
          this.$router.back()
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
